import { useState } from "react";

const portfolioItems = [
  // Weddings - 4 images from website
  {
    id: 1,
    category: "weddings",
    title: "Weddings",
    image: "https://static.wixstatic.com/media/3a96ea_64b80372f19347d79b2d76c488a1aa55~mv2.jpeg/v1/fill/w_980,h_749,q_90,enc_avif,quality_auto/3a96ea_64b80372f19347d79b2d76c488a1aa55~mv2.jpeg",
    alt: "Brittany Bailey Wedding Photography",
    span: "col-span-12 md:col-span-8 row-span-2",
  },
  {
    id: 9,
    category: "weddings",
    title: "Weddings",
    image: "https://static.wixstatic.com/media/3a96ea_18b45f5119ee4780a88ee45ba0d09ffd~mv2.jpg/v1/fill/w_485,h_323,q_90,enc_avif,quality_auto/3a96ea_18b45f5119ee4780a88ee45ba0d09ffd~mv2.jpg",
    alt: "Wedding bridesmaids",
    span: "col-span-6 md:col-span-4 row-span-1",
  },
  {
    id: 10,
    category: "weddings",
    title: "Weddings",
    image: "https://static.wixstatic.com/media/3a96ea_8772888651704ce197157035538ff717~mv2.jpg/v1/fill/w_502,h_764,q_90,enc_avif,quality_auto/3a96ea_8772888651704ce197157035538ff717~mv2.jpg",
    alt: "Bride portrait",
    span: "col-span-6 md:col-span-4 row-span-1",
  },
  {
    id: 11,
    category: "weddings",
    title: "Weddings",
    image: "https://static.wixstatic.com/media/3a96ea_f473ca6f56824cf89f2cb744b5bf4471~mv2.jpg/v1/fill/w_469,h_764,q_90,enc_avif,quality_auto/3a96ea_f473ca6f56824cf89f2cb744b5bf4471~mv2.jpg",
    alt: "Bride by window",
    span: "col-span-6 md:col-span-4 row-span-1",
  },
  // Seniors - 4 images from website
  {
    id: 2,
    category: "seniors",
    title: "Seniors",
    image: "https://static.wixstatic.com/media/3a96ea_30ba8b37d4834f4b894fbabc3396693f~mv2.jpeg/v1/fill/w_507,h_760,q_90,enc_avif,quality_auto/3a96ea_30ba8b37d4834f4b894fbabc3396693f~mv2.jpeg",
    alt: "Senior portrait session",
    span: "col-span-12 md:col-span-4 row-span-1",
  },
  {
    id: 13,
    category: "seniors",
    title: "Seniors",
    image: "https://static.wixstatic.com/media/3a96ea_a3bc3884e37042b6bcb6a4daa3b17cf4~mv2.jpg/v1/fill/w_306,h_496,q_90,enc_avif,quality_auto/3a96ea_a3bc3884e37042b6bcb6a4daa3b17cf4~mv2.jpg",
    alt: "Senior portrait outdoors",
    span: "col-span-6 md:col-span-4 row-span-1",
  },
  {
    id: 14,
    category: "seniors",
    title: "Seniors",
    image: "https://static.wixstatic.com/media/3a96ea_82de2f227eb64f6e9c282930d2e44ac4~mv2.jpg/v1/fill/w_324,h_496,q_90,enc_avif,quality_auto/3a96ea_82de2f227eb64f6e9c282930d2e44ac4~mv2.jpg",
    alt: "Senior portrait lifestyle",
    span: "col-span-6 md:col-span-4 row-span-1",
  },
  {
    id: 15,
    category: "seniors",
    title: "Seniors",
    image: "https://static.wixstatic.com/media/3a96ea_b7418efceae14904bb8ddad866be646c~mv2.jpg/v1/fill/w_330,h_496,q_90,enc_avif,quality_auto/3a96ea_b7418efceae14904bb8ddad866be646c~mv2.jpg",
    alt: "Senior portrait natural light",
    span: "col-span-6 md:col-span-4 row-span-1",
  },
  // Family - 4 images from website
  {
    id: 3,
    category: "family",
    title: "Family",
    image: "https://static.wixstatic.com/media/3a96ea_e0c10ab5d70c476298f245938b6a4c67~mv2.jpeg/v1/fill/w_980,h_733,q_90,enc_avif,quality_auto/3a96ea_e0c10ab5d70c476298f245938b6a4c67~mv2.jpeg",
    alt: "Family portrait session",
    span: "col-span-12 md:col-span-4 row-span-1",
  },
  {
    id: 16,
    category: "family",
    title: "Family",
    image: "https://static.wixstatic.com/media/3a96ea_99f9e83075124bea865cf2c932373a40~mv2.jpg/v1/fill/w_510,h_340,q_90,enc_avif,quality_auto/3a96ea_99f9e83075124bea865cf2c932373a40~mv2.jpg",
    alt: "Family playful moment",
    span: "col-span-6 md:col-span-4 row-span-1",
  },
  {
    id: 17,
    category: "family",
    title: "Family",
    image: "https://static.wixstatic.com/media/3a96ea_f25826fd15ee472689e450c2ee23ffec~mv2.jpg/v1/fill/w_460,h_340,q_90,enc_avif,quality_auto/3a96ea_f25826fd15ee472689e450c2ee23ffec~mv2.jpg",
    alt: "Family portrait",
    span: "col-span-6 md:col-span-4 row-span-1",
  },
  {
    id: 18,
    category: "family",
    title: "Family",
    image: "https://static.wixstatic.com/media/3a96ea_44a507acaa9e42b79b83e08e36737466~mv2.jpeg/v1/fill/w_345,h_415,q_90,enc_avif,quality_auto/3a96ea_44a507acaa9e42b79b83e08e36737466~mv2.jpeg",
    alt: "Family outdoors",
    span: "col-span-6 md:col-span-4 row-span-1",
  },
  // Boudoir - 4 images from website
  {
    id: 4,
    category: "boudoir",
    title: "Boudoir",
    image: "https://static.wixstatic.com/media/3a96ea_de742eae6ad0493f90e9003c53d30682~mv2.jpeg/v1/fill/w_299,h_447,q_90,enc_avif,quality_auto/3a96ea_de742eae6ad0493f90e9003c53d30682~mv2.jpeg",
    alt: "Elegant boudoir session",
    span: "col-span-12 md:col-span-4 row-span-1",
  },
  {
    id: 19,
    category: "boudoir",
    title: "Boudoir",
    image: "https://static.wixstatic.com/media/3a96ea_89c0960ee1c247fb97d298e509bceb26~mv2.jpeg/v1/fill/w_506,h_729,q_90,enc_avif,quality_auto/3a96ea_89c0960ee1c247fb97d298e509bceb26~mv2.jpeg",
    alt: "Boudoir portrait",
    span: "col-span-6 md:col-span-4 row-span-1",
  },
  {
    id: 20,
    category: "boudoir",
    title: "Boudoir",
    image: "https://static.wixstatic.com/media/3a96ea_c166b2b2c099452886a40c8388e4b9a0~mv2.jpeg/v1/fill/w_466,h_754,q_90,enc_avif,quality_auto/3a96ea_c166b2b2c099452886a40c8388e4b9a0~mv2.jpeg",
    alt: "Boudoir natural light",
    span: "col-span-6 md:col-span-4 row-span-1",
  },
  {
    id: 21,
    category: "boudoir",
    title: "Boudoir",
    image: "https://static.wixstatic.com/media/3a96ea_3bfc3ec843084a1fb49db815da19cf74~mv2.jpeg/v1/fill/w_671,h_447,q_90,enc_avif,quality_auto/3a96ea_3bfc3ec843084a1fb49db815da19cf74~mv2.jpeg",
    alt: "Boudoir lifestyle",
    span: "col-span-6 md:col-span-4 row-span-1",
  },
  // Branding - 3 images from website
  {
    id: 5,
    category: "branding",
    title: "Branding",
    image: "https://static.wixstatic.com/media/3a96ea_ef68dfd7ec194aadbf566e21b9509460~mv2.jpg/v1/fill/w_980,h_1146,q_90,enc_avif,quality_auto/3a96ea_ef68dfd7ec194aadbf566e21b9509460~mv2.jpg",
    alt: "Professional branding session",
    span: "col-span-12 md:col-span-4 row-span-1",
  },
  {
    id: 22,
    category: "branding",
    title: "Branding",
    image: "https://static.wixstatic.com/media/3a96ea_f7ae28304ab5406eae279b6b10405bbf~mv2.jpg/v1/fill/w_505,h_712,q_90,enc_avif,quality_auto/3a96ea_f7ae28304ab5406eae279b6b10405bbf~mv2.jpg",
    alt: "Headshot branding portrait",
    span: "col-span-6 md:col-span-4 row-span-1",
  },
  {
    id: 23,
    category: "branding",
    title: "Branding",
    image: "https://static.wixstatic.com/media/3a96ea_d54a403aa9d34d85afac3d2d0cb0111c~mv2.jpg/v1/fill/w_465,h_712,q_90,enc_avif,quality_auto/3a96ea_d54a403aa9d34d85afac3d2d0cb0111c~mv2.jpg",
    alt: "Business branding photography",
    span: "col-span-6 md:col-span-4 row-span-1",
  },
  // Maternity - 4 images from website
  {
    id: 6,
    category: "maternity",
    title: "Maternity",
    image: "https://static.wixstatic.com/media/3a96ea_fb4ed5324cc243d68bc050706da052d6~mv2.jpeg/v1/fill/w_487,h_726,q_90,enc_avif,quality_auto/3a96ea_fb4ed5324cc243d68bc050706da052d6~mv2.jpeg",
    alt: "Beautiful maternity session",
    span: "col-span-12 md:col-span-4 row-span-1",
  },
  {
    id: 25,
    category: "maternity",
    title: "Maternity",
    image: "https://static.wixstatic.com/media/3a96ea_3d589490c7704fb5a6db226bbe38ef07~mv2.jpg/v1/fill/w_304,h_497,q_90,enc_avif,quality_auto/3a96ea_3d589490c7704fb5a6db226bbe38ef07~mv2.jpg",
    alt: "Maternity outdoor portrait",
    span: "col-span-6 md:col-span-4 row-span-1",
  },
  {
    id: 26,
    category: "maternity",
    title: "Maternity",
    image: "https://static.wixstatic.com/media/3a96ea_2fb581bb64fd41f5906f6f1b9a28fab0~mv2.jpg/v1/fill/w_325,h_497,q_90,enc_avif,quality_auto/3a96ea_2fb581bb64fd41f5906f6f1b9a28fab0~mv2.jpg",
    alt: "Maternity couple portrait",
    span: "col-span-6 md:col-span-4 row-span-1",
  },
  {
    id: 27,
    category: "maternity",
    title: "Maternity",
    image: "https://static.wixstatic.com/media/3a96ea_71cf1dc8fd714b84a0a7370922505c90~mv2.jpeg/v1/fill/w_331,h_497,q_90,enc_avif,quality_auto/3a96ea_71cf1dc8fd714b84a0a7370922505c90~mv2.jpeg",
    alt: "Maternity golden hour",
    span: "col-span-6 md:col-span-4 row-span-1",
  },
  // Couples - 3 images from website
  {
    id: 7,
    category: "couples",
    title: "Couples",
    image: "https://static.wixstatic.com/media/3a96ea_468f6f8dbf52444a9eee07649207629b~mv2.jpeg/v1/fill/w_980,h_797,q_90,enc_avif,quality_auto/3a96ea_468f6f8dbf52444a9eee07649207629b~mv2.jpeg",
    alt: "Romantic couples session",
    span: "col-span-12 md:col-span-6 row-span-1",
  },
  {
    id: 28,
    category: "couples",
    title: "Couples",
    image: "https://static.wixstatic.com/media/3a96ea_50a574b440ea43d181966cc71c695258~mv2.jpeg/v1/fill/w_439,h_661,q_90,enc_avif,quality_auto/3a96ea_50a574b440ea43d181966cc71c695258~mv2.jpeg",
    alt: "Engagement portrait",
    span: "col-span-6 md:col-span-3 row-span-1",
  },
  {
    id: 29,
    category: "couples",
    title: "Couples",
    image: "https://static.wixstatic.com/media/3a96ea_a8dbdc27a0f248f5879c6998465d1d03~mv2.jpg/v1/fill/w_531,h_661,q_90,enc_avif,quality_auto/3a96ea_a8dbdc27a0f248f5879c6998465d1d03~mv2.jpg",
    alt: "Couple outdoor session",
    span: "col-span-6 md:col-span-3 row-span-1",
  },
  // Newborn - 4 images from website
  {
    id: 8,
    category: "newborn",
    title: "Lifestyle Newborn",
    image: "https://static.wixstatic.com/media/3a96ea_e9dd9c9f26bc468587ffd766634fa985~mv2.jpg/v1/fill/w_980,h_653,q_90,enc_avif,quality_auto/3a96ea_e9dd9c9f26bc468587ffd766634fa985~mv2.jpg",
    alt: "Precious newborn session",
    span: "col-span-12 md:col-span-6 row-span-1",
  },
  {
    id: 31,
    category: "newborn",
    title: "Lifestyle Newborn",
    image: "https://static.wixstatic.com/media/3a96ea_0b3c5e2a30de493bbd306ab8abb227a6~mv2.jpg/v1/fill/w_980,h_653,q_90,enc_avif,quality_auto/3a96ea_0b3c5e2a30de493bbd306ab8abb227a6~mv2.jpg",
    alt: "Family with newborn",
    span: "col-span-6 md:col-span-3 row-span-1",
  },
  {
    id: 32,
    category: "newborn",
    title: "Lifestyle Newborn",
    image: "https://static.wixstatic.com/media/3a96ea_e18c5583a2ee43bc8e1aa96bbc1a6a69~mv2.jpeg/v1/fill/w_485,h_729,q_90,enc_avif,quality_auto/3a96ea_e18c5583a2ee43bc8e1aa96bbc1a6a69~mv2.jpeg",
    alt: "Newborn portrait",
    span: "col-span-6 md:col-span-3 row-span-1",
  },
  {
    id: 33,
    category: "newborn",
    title: "Lifestyle Newborn",
    image: "https://static.wixstatic.com/media/3a96ea_f4ccda1c05d24997bcc43c8d7c06d94f~mv2.jpg/v1/fill/w_485,h_729,q_90,enc_avif,quality_auto/3a96ea_f4ccda1c05d24997bcc43c8d7c06d94f~mv2.jpg",
    alt: "Baby lifestyle",
    span: "col-span-6 md:col-span-4 row-span-1",
  },
];

const categories = ["all", "weddings", "seniors", "family", "boudoir", "branding", "maternity", "couples", "newborn"];

const PortfolioSection = ({ isVisible }) => {
  const [activeCategory, setActiveCategory] = useState("all");

  // For "all" tab, show only the first image from each category
  const getFilteredItems = () => {
    if (activeCategory === "all") {
      const seenCategories = new Set();
      return portfolioItems.filter((item) => {
        if (seenCategories.has(item.category)) {
          return false;
        }
        seenCategories.add(item.category);
        return true;
      });
    }
    return portfolioItems.filter((item) => item.category === activeCategory);
  };

  const filteredItems = getFilteredItems();

  return (
    <section
      id="portfolio"
      className="py-24 lg:py-32 bg-[#F5F2EB]"
      data-testid="portfolio-section"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Header */}
        <div
          className={`text-center mb-16 ${
            isVisible ? "animate-fade-in-up" : "opacity-0"
          }`}
        >
          <p className="overline text-[#C8A99C] mb-4">My Work</p>
          <h2 className="font-heading text-4xl lg:text-5xl font-light tracking-tight text-[#2C2A28] mb-6">
            Portfolio
          </h2>
          <div className="section-divider mx-auto" />
        </div>

        {/* Category Filter */}
        <div
          className={`flex flex-wrap justify-center gap-3 mb-12 ${
            isVisible ? "animate-fade-in-up animation-delay-100" : "opacity-0"
          }`}
        >
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setActiveCategory(category)}
              className={`px-5 py-2 font-body text-sm tracking-wide transition-all duration-300 ${
                activeCategory === category
                  ? "bg-[#2C2A28] text-[#FDFBF9]"
                  : "bg-transparent border border-[#E8E4DD] text-[#5C5A56] hover:border-[#2C2A28] hover:text-[#2C2A28]"
              }`}
              data-testid={`filter-${category}`}
            >
              {category.charAt(0).toUpperCase() + category.slice(1)}
            </button>
          ))}
        </div>

        {/* Portfolio Grid */}
        <div
          className={`grid grid-cols-12 gap-4 lg:gap-6 auto-rows-[200px] lg:auto-rows-[250px] ${
            isVisible ? "animate-fade-in-up animation-delay-200" : "opacity-0"
          }`}
        >
          {filteredItems.map((item, index) => (
            <div
              key={item.id}
              className={`portfolio-item ${item.span} group cursor-pointer`}
              data-testid={`portfolio-item-${item.id}`}
            >
              <div className="relative w-full h-full overflow-hidden">
                <img
                  src={item.image}
                  alt={item.alt}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#2C2A28]/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                <div className="absolute bottom-0 left-0 right-0 p-6 translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500">
                  <p className="font-heading text-2xl text-[#FDFBF9]">{item.title}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PortfolioSection;
